// import "../../styling/style.css";
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, FormikErrors } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import AutocompleteComponent from "../../components/autocomplete/autocomplete-mui";
import CRRNumberField from "../../components/crrnumberfield/crr-number-field-mui";
import ConfirmationDialog from "../../components/dialog/simple-alert";
import DialogQuestionnaire from "../../components/dialogquestionnaire/dialog-questionnaire";
import DropdownlistComponent from "../../components/dropdownlist/dropdownlist-mui";
import DropdownlistComponentValidation from "../../components/dropdownlistvalidation/dropdownlist-validation-mui";
import Feedback from "../../components/feedback/feedback";
import FeedbackNotification from "../../components/feedbacknotification/feedback-notification";
import Loading from "../../components/loading/loading";
import TextFieldComponent from "../../components/textfield/textfield-mui";
import TextFieldDateComponent from "../../components/textfielddate/textfield-date-mui";
import TextFieldDateValidationComponent from "../../components/textfielddatevalidation/textfield-date-validation-mui";
import TextFieldDisabledComponent from "../../components/textfielddisabled/textfield-disabled-mui";
import TextFieldMultiComponent from "../../components/textfieldmulti/textfield-multi-mui";
import TextFieldMultiDisabledComponent from "../../components/textfieldmultidisabled/textfield-multi-disabled-mui";
import UploadMultipleFileComponent from "../../components/uploadmultiplefile/UploadMultipleFile";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IForm } from "../../interfaces/IForm";
import { DocumentType, RequestStatus, RequestType } from "../../shared/Enum";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";
import { selectUserProfile } from "../../store/auth/selector";
import { homeStyle } from "../../styles/container/home";
import {
  getListAreaLocation,
  getListDocumentType,
  getListRequestType,
  InsertForm,
} from "./api-endpoint/callApi";

const getBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.addEventListener("error", (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });

function CreateForm() {
  const [listDocumentType, setListDocumentType] = useState([]);
  const [listAreaLocation, setListAreaLocation] = useState([]);
  const [listRequestType, setListRequestType] = useState([]);
  const [validationDocumentType, setValidationDocumentType] = useState(
    DocumentType.toId(DocumentType.Softcopy)
  );
  const [validationRequestType, setValidationRequestType] = useState(
    RequestType.toId(RequestType.SuratKuasa)
  );
  const [requestNumber, setRequestNumber] = useState("");
  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah Draft Final / Upload Final Draft*",
      fileType: "Draft Final",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);
  const [valueTab, setValueTab] = useState(0);
  const profile = useSelector(selectUserProfile);
  const today = new Date();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const reqDate = `${today.getDate()} ${
    month[today.getMonth()]
  } ${today.getFullYear()}`;
  const Navigate = useNavigate();
  const [errorUpload, setErrorUpload] = useState("");
  const [loadingActive, setLoadingActive] = useState(false);
  const [formData, setFormData] = useState<IForm | undefined>();
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openFeedbackNotification, setOpenFeedbackNotification] =
    useState(false);
  const [actionClick, setActionClick] = useState("");
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);

  const [crrNumber, setCrrNumber] = useState("");
  const [crrNumError, setCrrError] = useState("");

  const initialValues: IForm = {
    startDatePeriod: "",
    endDatePeriod: "",
    binusianID: profile.BinusianId,
    email: profile.Email,
    binusianName: profile.Name,
    businessUnit: profile.BusinessUnit,
    department: profile.Department,
    title: profile.JobTitle,
    buLeader: profile.BULeaderName,
    extension: "",
    documentType: DocumentType.toId(DocumentType.Softcopy),
    requestType: RequestType.toId(RequestType.SuratKuasa),
    dateOfPower: "",
    dateGrantOfPower: "",
    clNote: "",
    lrNote: "",
    signer: { name: "Tidak ada", binusianIDEmail: "Tidak ada~Tidak ada" },
    titleAgreement: "",
    area: "Anggrek",
    address: "",
    counterPart: "",
    requestDate: reqDate,
    substitutor: null,
    delegatee: null,
    noPowerAttorney: "",
    noSubstitutor: "",
  };

  const getRequestType = async () => {
    try {
      // get all data for table list User
      const msRequestType = await getListRequestType();
      setListRequestType(msRequestType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getDocumentType = async () => {
    try {
      // get all data for table list User
      const ltDocumentType = await getListDocumentType();
      setListDocumentType(ltDocumentType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getAreaLocation = async () => {
    try {
      // get all data for table list User
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);
      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });

      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      const filterAscLocation: any = distinctLocation.sort(
        (a: any, b: any) => a.value - b.value
      );
      setListAreaLocation(distinctLocation);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await getDocumentType();
      await getAreaLocation();
      await getRequestType();
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  const validation = (values: IForm) => {
    const errors: FormikErrors<IForm | undefined> = {};

    if (values.dateOfPower === "") {
      errors.dateOfPower = "Date of Power of Attorney must be filled";
    }
    if (
      values.requestType == RequestType.toId(RequestType.DokumenMaster) &&
      values.startDatePeriod == ""
    ) {
      errors.startDatePeriod = "Period of Use must be filled";
    }
    if (values.startDatePeriod !== "" && values.endDatePeriod === "") {
      errors.endDatePeriod = "End Date Period must be filled";
    }
    if (values.startDatePeriod === "" && values.endDatePeriod !== "") {
      errors.startDatePeriod = "Start Date Period must be filled";
    }
    if (
      values.startDatePeriod !== "" &&
      values.endDatePeriod !== "" &&
      values.endDatePeriod < values.startDatePeriod
    ) {
      errors.endDatePeriod = "End Date must not be earlier than Start Date";
    }
    if (values.titleAgreement === "") {
      errors.titleAgreement = "Title of Agreement must be filled";
    }
    if (
      values.address === "" &&
      values.documentType == DocumentType.toId(DocumentType.Hardcopy)
    ) {
      errors.address = "Address must be filled";
    }
    if (values.counterPart === "") {
      errors.counterPart = "Counterpart must be filled";
    }
    if (values.signer === null) {
      errors.signer = "Signer must be filled";
    }

    const checkFileRequired = dataUpload.some(
      (item) =>
        item.title.includes("*") &&
        item.files.some((file) => file.fileName === "")
    );

    if (checkFileRequired) {
      setErrorUpload("Please upload required file");
    } else {
      setErrorUpload("");
    }

    if (values.extension.length > 100) {
      errors.extension = "Extension cannot be more than 100 letters!";
      setValueTab(0);
    }

    return errors;
  };

  const onSubmitForm = async (values: IForm) => {
    const updatedValues = { ...values };
    if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
      updatedValues.area = "-";
      updatedValues.address = "-";
    }
    setFormData(updatedValues);

    if (errorUpload == "" && !crrNumError) {
      setActionClick("submit");
      setOpenConfirmation(true);
    }
  };

  const handleSaveOrSubmit = async () => {
    setOpenConfirmation(false);
    setLoadingActive(true);
    if (actionClick == "submit") {
      const submit = await InsertForm(
        formData,
        dataUpload,
        RequestStatus.toId(RequestStatus.RequestReceive),
        crrNumber
      );
      setLoadingActive(false);
      if (submit.resultCode === 200) {
        setRequestNumber(submit.data.requestNumber);
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
          setOpenFeedbackNotification(true);
        }, 2000);
      } else {
        setFeedbackText(submit.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    } else {
      const save = await InsertForm(
        formData,
        dataUpload,
        RequestStatus.toId(RequestStatus.Draft),
        crrNumber
      );
      setLoadingActive(false);
      if (save.resultCode === 200) {
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        setTimeout(() => {
          Navigate("/");
        }, 3000);
      } else {
        setFeedbackText(save.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    }
  };

  const handleSaveAsDraft = async (props) => {
    const formikErrors = validation(props.values);

    if (Object.keys(formikErrors).length === 0 && !crrNumError) {
      const updatedValues = { ...props.values };
      if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
        updatedValues.area = "-";
        updatedValues.address = "-";
      }
      setFormData(updatedValues);
      if (errorUpload == "") {
        setActionClick("save");
        setOpenConfirmation(true);
      }
    } else {
      props.setErrors(formikErrors);
    }
  };

  const onResetForm = () => {
    // dia otomatis bakal mengikuti value awal formik saat reset
    setValidationDocumentType(DocumentType.toId(DocumentType.Softcopy));
    setErrorUpload("");
    setDataUpload([
      {
        title: "Unggah Draft Final / Upload Final Draft*",
        fileType: "Draft Final",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      },
    ]);
    setCrrNumber("");
    setCrrError("");
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChangeUpload = async (data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newDataUpload = [...dataUpload];
      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileName = !newDataUpload.some((item) =>
        item.files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        })
      );

      if (filteredSameFileName) {
        newDataUpload[dataIndex] = {
          title: newDataUpload[dataIndex].title,
          fileType: newDataUpload[dataIndex].fileType,
          files: [...newDataUpload[dataIndex].files],
        };
        newDataUpload[dataIndex].files[fileIndex] = {
          documentID: "",
          fileBase64: resultBase64File,
          fileName: data.name,
          folderName: "",
        };
        setDataUpload(newDataUpload);
        if (
          newDataUpload[dataIndex].title.includes("*") &&
          newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
        ) {
          setErrorUpload("");
        }
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const handleChangeDelete = (dataIndex: number, fileIndex: number) => {
    const newDataUpload = [...dataUpload];
    newDataUpload[dataIndex].files[fileIndex] = {
      documentID: "",
      fileBase64: "",
      fileName: "",
      folderName: "",
    };
    setDataUpload(newDataUpload);
    if (
      newDataUpload[dataIndex].title.includes("*") &&
      newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
    ) {
      setErrorUpload("Please upload required file");
    }
  };

  const handleChangeDownload = (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");
    if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
      downloadLink.href = getDataUpload[dataIndex].files[fileIndex].fileBase64;
      downloadLink.download =
        getDataUpload[dataIndex].files[fileIndex].fileName;
      downloadLink.click();
    }
  };

  const handleChangeDateOfPower = (date) => {
    const dateChoosen = new Date(date).setHours(0, 0, 0, 0);
    const dateToday = new Date().setHours(0, 0, 0, 0);

    if (dateChoosen < dateToday && dataUpload.length == 1) {
      setDataUpload((prev) => [
        ...prev,
        {
          title: "Approval BU Leader / BU Leader Approval*",
          fileType: "Approval BU Leader",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
        {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ]);
    }

    if (dateChoosen >= dateToday && dataUpload.length > 1) {
      setDataUpload((prev) => [prev[0]]);
    }

    setErrorUpload("");
  };

  const handleOk = () => {
    Navigate("/");
  };

  const handleCRRChange = (value: string, error?: string) => {
    setCrrNumber(value);
    setCrrError(error || "");
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px", padding: 0, margin: 0 }}>
        <div className="tabs-container">Home {">"} Add New Request</div>
        <div className="tabs-container">
          <hr style={{ color: "black", width: "100%" }} />
        </div>
      </Box>
      {/* <Grid item lg={12} md={12} xs={12}>
        <Typography variant="subtitle1" gutterBottom>
          No Request / Request Number &emsp;&emsp;&emsp; : 001-SA-IX-2023
        </Typography>
      </Grid> */}
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              Tanggal Permintaan / <i>Request Date</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "200px" }}
          >
            <b>{initialValues.requestDate}</b>
          </Typography>
        </div>
      </Grid>
      <CRRNumberField
        crrNumber={crrNumber}
        crrNumError={crrNumError}
        onCRRChange={handleCRRChange}
      />
      <div className="tabs-container" style={{ marginTop: "1.5%" }}>
        <Tabs value={valueTab} onChange={handleChangeTab} textColor="primary">
          <Tab
            style={{ color: valueTab === 0 ? "#fff" : "#000" }}
            color="primary"
            label="Data Diri / Profile"
            className={valueTab === 0 ? "active-tab-panel" : "hidden-tab-panel"}
          />
          <Tab
            style={{ color: valueTab === 1 ? "#fff" : "#000" }}
            color="primary"
            label="Permohonan Detil / Detail Request"
            className={valueTab === 1 ? "active-tab-panel" : "hidden-tab-panel"}
          />
        </Tabs>
      </div>
      <div className="tabs-container">
        <hr className="tab-line" />
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitForm}
        validate={validation}
        onReset={onResetForm}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <TabPanel value={valueTab} index={0}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pemohon / <i>Applicant</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="binusianName"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jabatan / <i>Title</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent propsData={props} name="title" />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Divisi / <i>Business Unit</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="businessUnit"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "25px" }}
                    gutterBottom
                  >
                    <u>Business Unit Leader</u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="buLeader"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Department / <i>Department</i>
                    </u>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="department"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "40px" }}
                    gutterBottom
                  >
                    <u>
                      Ekstensi / <i>Extension</i> (Ext.)
                    </u>
                  </Typography>
                  <TextFieldComponent propsData={props} name="extension" />
                  {props.errors.extension && (
                    <div className="error-message">
                      {props.errors.extension}
                    </div>
                  )}
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  Next Page {">>"}
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Surat Kuasa / <i>Date of Power of Attorney</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateValidationComponent
                    propsData={props}
                    name="dateOfPower"
                    onChildDataChange={(dataChild) =>
                      handleChangeDateOfPower(dataChild)
                    }
                  />
                  {props.errors.dateOfPower && (
                    <div className="error-message">
                      {props.errors.dateOfPower}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pihak Penandatangan / <i>Signer</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <AutocompleteComponent
                    propsData={props}
                    name="signer"
                    optional
                  />
                  {props.errors.signer && (
                    <div className="error-message">{props.errors.signer}</div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Judul Perjanjian / <i>Title of Agreement</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldMultiComponent
                    propsData={props}
                    name="titleAgreement"
                  />
                  {props.errors.titleAgreement && (
                    <div className="error-message">
                      {props.errors.titleAgreement}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Partner / <i>Counterpart</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldComponent propsData={props} name="counterPart" />
                  {props.errors.counterPart && (
                    <div className="error-message">
                      {props.errors.counterPart}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Jenis Dokumen / <i>Document Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    onChildDataChange={(dataChild) =>
                      setValidationDocumentType(dataChild)
                    }
                    name="documentType"
                    ddlData={listDocumentType}
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {dataUpload.map((obj, i) => (
                    <div>
                      <UploadMultipleFileComponent
                        file={obj}
                        fileIndex={i}
                        onUploadFile={(data, fileIndex) => {
                          handleChangeUpload(data, i, fileIndex);
                        }}
                        onDeleteFile={(fileIndex) =>
                          handleChangeDelete(i, fileIndex)
                        }
                        onDownloadFile={(fileIndex) => {
                          handleChangeDownload(i, fileIndex);
                        }}
                        onAddMoreData={() => {
                          if (dataUpload[i].files.length < 5) {
                            setDataUpload((prevState) => {
                              const newState = [...prevState];
                              const emptyFile = {
                                documentID: "",
                                fileBase64: "",
                                fileName: "",
                                folderName: "",
                              };
                              if (i >= 0 && i < newState.length) {
                                newState[i].files.push(emptyFile);
                              }

                              return newState;
                            });
                          }
                        }}
                        onDeleteData={(ind) => {
                          setDataUpload((prevState) => {
                            const newState = [...prevState];
                            if (
                              i >= 0 &&
                              i < newState.length &&
                              ind >= 0 &&
                              ind < newState[i].files.length
                            ) {
                              newState[i].files.splice(ind, 1);
                            }

                            return newState;
                          });
                        }}
                        requiredValidationMessage={errorUpload}
                      />
                    </div>
                  ))}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) && (
                    <div style={{ paddingBottom: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Lokasi / <i>Area</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistComponent
                        propsData={props}
                        name="area"
                        ddlData={listAreaLocation}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingTop: "20px" }}
                      >
                        <u>
                          Ruang / <i>Room</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldMultiComponent
                        propsData={props}
                        name="address"
                      />
                      {props.errors.address && (
                        <div className="error-message">
                          {props.errors.address}
                        </div>
                      )}
                    </div>
                  )}
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Periode Penggunaan (Khusus Dokumen Master) /{" "}
                      <i>Period of Use (Master Document only)</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <Grid container spacing={3} item md={12} xs={12}>
                    <Grid item md={6} xs={6}>
                      <TextFieldDateComponent
                        propsData={props}
                        name="startDatePeriod"
                      />
                      {props.errors.startDatePeriod && (
                        <div className="error-message">
                          {props.errors.startDatePeriod}
                        </div>
                      )}
                    </Grid>
                    <Grid item md={6} xs={6}>
                      <TextFieldDateComponent
                        propsData={props}
                        name="endDatePeriod"
                      />
                      {props.errors.endDatePeriod && (
                        <div className="error-message">
                          {props.errors.endDatePeriod}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jenis Permohonan / <i>Request Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistComponentValidation
                    propsData={props}
                    name="requestType"
                    onChildDataChange={(dataChild) =>
                      setValidationRequestType(dataChild)
                    }
                    ddlData={listRequestType}
                  />
                </Grid>
              </Grid>

              <Grid container justifyContent="center" sx={{ mt: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => handleSaveAsDraft(props)}
                >
                  Save as Draft
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  type="submit"
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  type="reset"
                >
                  Reset
                </Button>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(0)}
                >
                  {"<<"} Previous Page
                </Button>
              </Box>

              <ConfirmationDialog
                open={openConfirmation}
                title="Confirmation"
                message="Are you sure you want to proceed ?"
                onConfirm={() => {
                  handleSaveOrSubmit();
                }}
                onCancel={() => {
                  setOpenConfirmation(false);
                }}
              />

              <FeedbackNotification
                open={openFeedbackNotification}
                title="Your Request Number:"
                message={requestNumber}
                onConfirm={() => {
                  handleOk();
                }}
              />

              {/* <Autocomplete
      id="asynchronous-demo"
      sx={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        setChangetText("");
      }}
      isOptionEqualToValue={(option, value) => option.documentID === value.documentID}
      getOptionLabel={(option) => option.documentName}
      options={options}
      noOptionsText="Please Type 3 Text"
      // loading={loading}
      // inputValue={inputValue}
      onChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={e => setChangetText(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {open && changeText.length > 0 ? <CircularProgress color="inherit" size={15} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    /> */}
            </TabPanel>
            <Loading open={loadingActive} />
            <Feedback
              open={openFeedback}
              message={feedbackText}
              feedbackType={feedbackType}
              onClose={() => {
                if (feedbackType == "failed") {
                  setOpenFeedback(false);
                }
              }}
            />
          </form>
        )}
      </Formik>

      <DialogQuestionnaire open={false} />
    </Container>

    // <Grid item lg={6} md={12} xs={12}>
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Komentar Legal / Comment from Legal
    //                 </Typography>
    //                 <TextFieldMultiDisabledComponent parentToChild="Komentarnya" />
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Bukti / Evidence
    //                 </Typography>
    //                 <DownloadFileComponent fileName="bukti.jpg" />
    //               </Grid>
    // <div>
    //   <h1>My Form</h1>
    //   <Formik
    //     initialValues={initialValues}
    //     onSubmit={onSubmitForm}
    //     validate={validation}
    //   >
    //     {(props) => (
    //       <form onSubmit={props.handleSubmit}>
    //         <TextFieldComponent propsData={props} name="name" />

    //         {/* <TextFieldComponent onChildDataChange={handleDataTextArea}/> */}
    //         {props.errors.name && (
    //           <div id="feedback">{props.errors.name}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="email" />
    //         {props.errors.email && (
    //           <div id="feedback">{props.errors.email}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="startDate" />
    //         {props.errors.startDate && (
    //           <div id="feedback">{props.errors.startDate}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="endDate" />
    //         {props.errors.endDate && (
    //           <div id="feedback">{props.errors.endDate}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="binusianName" />
    //         {props.errors.binusianName && (
    //           <div id="feedback">{props.errors.binusianName}</div>
    //         )}

    //         <button type="submit">Submit</button>
    //       </form>
    //     )}
    //   </Formik>
    // </div>

    // <Container>
    //   <DatePickerComponent onChildDataChange={handleDataFromChild}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea2}/>
    //   <DropdownlistComponent/>
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea}/> */}
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea2}/> */}
    // </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function padToEqualLength(text1, text2) {
  const maxLength = Math.max(text1.length, text2.length);
  const paddedText1 = text1.padEnd(maxLength, " ");
  const paddedText2 = text2.padEnd(maxLength, " ");
  return `${paddedText1} / ${paddedText2}`;
}

export default CreateForm;
